import React from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {H2, Body} from "@irati/ui/src/Typography"
import Loading from "@irati/ui/src/Loading"

import {StyledDiv} from "../PerksSettings/PerkVisibility/styled/PerksVisibility"
import CategoryList from "./WellbeingCategoryList"

export default function WellbeingContentVisibility() {
  return (
    <>
      <H2>
        <FormattedMessage id="platform.adminNavigation.secondary.wellbeingContentVisibility" />
      </H2>
      <Body marginBottom={5} marginTop={2}>
        <FormattedMessage id="admin.components.wellbeing.headerTwo" />
      </Body>
      <StyledDiv>
        <div className="text-left">
          <Loading>
            <CategoryList />
          </Loading>
        </div>
      </StyledDiv>
    </>
  )
}
